import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    minHeight: 'calc(100% - 52px)',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems : 'center'
    },
  },
  leftSide: {
    minWidth: '340px',
    width: '340px',
    boxShadow: 'inset -1px 0px 0px #e2ebf6',
    padding: '12px 30px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: '100%',
      boxShadow: 'none',
      padding: '10px 40px',
    },
  },
  rightSide: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px',
    },
  },
  bookWrapper: {
    width: '618px',
    padding: '30px 0 36px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      // padding: '20px 0 30px',
    },
  },
  fontWeight: {
    fontWeight: 'bold',
  },
  productCode: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.035em',
    marginBottom: '6px',
  },
  photo: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    width: '100%',
    height: '180px',
    border: '1px solid #BECEDA',
    backgroundColor: '#E2F5F8',
    marginBottom: '24px',
  },
  listInfo: {
    margin: '18px 0',
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
  },
  infoIcon: {
    fontSize: '16px',
    marginRight: '15px',
  },
  overview: {
    marginBottom: '24px',
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important',
  },
  loaderWrapper: {
    position: 'fixed',
  },
  sectionIndent: {
    marginBottom: '42px',
    [theme.breakpoints.down('sm')]:{
      paddingLeft: '20px'
    }

  },
  inputIndent: {
    marginBottom: '24px',
  },
  currencyInput: {
    width: '190px',
    [theme.breakpoints.down('sm')]:{
     width: '90%',
     padding: '20px 20px'
    }
  },
  accommodationsTitle: {
    marginBottom: '13px',
    [theme.breakpoints.down('sm')]:{
      
    }
  },
  paymentWrapper: {
    borderBottom: '1px solid #e2ebf6',
    paddingBottom: '10px',
    marginBottom: '42px',
    [theme.breakpoints.down('sm')]:{
     paddingLeft: '20px'
    }
  },
  payment: {
    marginBottom: '13px',

  },
  paymentField: {
    marginBottom: 0,
  },
  addOnTitle: {
    fontSize: '13px',
    [theme.breakpoints.down('sm')]:{
    //  textAlign: 'center'
    }
  },
  addOnDescClass: {
    width: 'calc(100% - 163px)',
    [theme.breakpoints.down('sm')]: {
      
    },
  },
  disableInputFocus: {
    boxShadow: 'none !important',
    display: 'none !important '
  },
  inputIndent:{
    [theme.breakpoints.down('sm')]:{
      paddingLeft: '20px'
    }
  },
  smallCalendar: {
    width: '100%',
    paddingLeft: '20px'
 
  },
 

}));

export default useStyles;
